import { QueryClient } from '@tanstack/react-query';

const queryClient = new QueryClient();

const queryKeys = {
  datoData: 'dato-data'
};

export { queryClient, queryKeys };
